/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import type { NodeProps } from '../../../contextree/types';
import AnnotationsHandler from '../..';
import { C11nEnv } from '../../../interpreter/c11n-env';

import { createExpression, buildAST, evaluateExpression } from './utils';

AnnotationsHandler.registerHandler('@E', (value: string, c11nEnv: C11nEnv, contextTreeNodeProps?: NodeProps) => {
  try {
    const expression = createExpression(value);
    const exprAst = buildAST(expression);
    return evaluateExpression(exprAst, c11nEnv, contextTreeNodeProps);
  } catch (e) {
    /* empty catch block */
  }
  return true;
});
